import { HttpEvent, HttpRequest, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { OCP_APIM_SUBSCRIPTION_PARAM } from '../core.constants';

export const ocpApimSubscriptionInterceptor: HttpInterceptorFn = (
  httpRequest: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> =>
  next(
    httpRequest.clone({
      setParams: { [OCP_APIM_SUBSCRIPTION_PARAM]: environment.ocpApimSubscriptionKey },
    })
  );
